/**
 * QueryProvider - Wraps app with caching
 */

import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { queryClient, idbPersister } from './queryClient';

const QueryProvider = ({ children }) => {
    return (
        <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{
                persister: idbPersister,
                maxAge: 1000 * 60 * 60 * 24, // 24 hours
            }}
            onSuccess={() => {
                // Restored cache is shown instantly, but a query restored from
                // disk (up to 24h old) shouldn't be trusted as fresh just
                // because it survived -- silently refetch everything in the
                // background right after restore instead of waiting out
                // staleTime with refetchOnWindowFocus/refetchOnReconnect off.
                queryClient.invalidateQueries();
            }}
        >
            {children}
        </PersistQueryClientProvider>
    );
};

export default QueryProvider;
